var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar-box"},[(_vm.list)?_c('bv-tab-bar',{staticStyle:{"box-shadow":"0 4px 18px rgba(0,0,0,0.1) !important"},attrs:{"list":_vm.list,"active-class-name":'bc-t-blue',"active-index":_vm.activeIndex}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }